<template>
  <div class="vx-row min-h-screen">
    <div class="vx-col w-full">
      <header-public></header-public>
    </div>
    <div class="vx-col w-full">
      <div
        v-if="restaurant.images[0]"
        class="container w-full max-w-5xl mx-auto bg-white bg-center bg-cover bg-no-repeat md:rounded"
        :style="{
          'background-image': 'url(' + restaurant.images[0].path + ')',
          height: '48vh',
          position: 'relative',
          zIndex: '1',
        }"
      ></div>

      <!--Container-->
      <div
        class="container max-w-4xl mx-auto mb-8"
        :class="{ '-mt-48': restaurant.images[0], 'mt-8': !restaurant.images[0] }"
        style="position: relative; z-index: 2"
      >
        <div class="bg-white p-6 md:p-8 text-gray-800 leading-normal shadow-md rounded-lg text-justify">
          <restaurant-info :restaurant="restaurant"></restaurant-info>
          <ul class="flex my-6 border-b-2">
            <li class="mr-2 text-center">
              <span class="text-center block font-bold py-2 px-4 hover:text-petrol text-pink-500 border-bt">{{
                $t('restaurant.SobreNosotros')
              }}</span>
            </li>
            <li class="mr-2 text-center" v-if="allowCartes">
              <router-link
                :to="{ name: 'publicCarta', params: { id: cartes[0].id, slug: restaurant.slug, lang: language } }"
              >
                <span class="text-center block hover:text-petrol py-2 px-4" v-if="allowCartes">{{
                  $t('carta.Carta')
                }}</span>
              </router-link>
            </li>
            <li class="text-center" v-if="allowMenus">
              <router-link
                :to="{ name: 'publicMenu', params: { id: menus[0].id, slug: restaurant.slug, lang: language } }"
              >
                <span class="text-center block hover:text-petrol py-2 px-4" v-if="allowMenus">{{
                  $t('menu.Menu')
                }}</span>
              </router-link>
            </li>
          </ul>

          <div class="description" v-if="restaurant.description">
            <p>{{ restaurant.description }}</p>
          </div>

          <h2 v-if="types" class="text-lg font-bold mt-4 mb-2">{{ $t('restaurant.TipoEstablecimiento') }}</h2>
          <p v-if="types">{{ types }}</p>

          <h2 v-if="profiles" class="text-lg font-bold mt-4 mb-2">{{ $t('restaurant.PerfilEstablecimiento') }}</h2>
          <p v-if="profiles">{{ profiles }}</p>

          <h2 class="text-lg font-bold mt-4 mb-2">{{ $t('restaurant.RangoDePrecios') }}</h2>
          <p>{{ restaurant.prices }}</p>

          <h2 class="text-lg font-bold mt-4 mb-2">{{ $t('restaurant.Servicios') }}</h2>

          <div class="tags float-none">
            <span
              class="px-3 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
              v-if="restaurant[index]"
              v-for="(service, index) in services"
            >
              {{ service }}
            </span>
          </div>

          <span class="clearfix"></span>

          <h2 class="text-lg font-bold mt-4 mb-2">{{ $t('restaurant.MetodosDePago') }}</h2>
          <div class="tags float-none">
            <span
              class="px-3 py-1 rounded mr-2 mb-2 bg-grey-light text-sm inline-block"
              v-if="restaurant[index]"
              v-for="(pay, index) in payment"
            >
              {{ pay }}
            </span>
          </div>

          <span class="clearfix"></span>
        </div>
      </div>
    </div>
    <div class="vx-col w-full self-end" style="position: relative; z-index: 2">
      <footer-public :restaurant="restaurant"></footer-public>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RestaurantInfo from '../Restaurants/RestaurantInfo';
import FooterPublic from '../Public/Footer';
import HeaderPublic from '../Public/Header';
export default {
  components: {
    RestaurantInfo,
    HeaderPublic,
    FooterPublic,
  },
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      services: {
        animation: this.$t('services.Animacion'),
        covid_free: this.$t('services.LibreDeCovid'),
        digital_menu: this.$t('services.MenuDigital'),
        food_delivery: this.$t('services.EntregaDeComida'),
        kid_area: this.$t('services.AreaNinos'),
        kid_friendly: this.$t('services.NinosFriendly'),
        parking: this.$t('services.Parking'),
        pet_friendly: this.$t('services.MascotasFriendly'),
        pmr: this.$t('services.PersonasMovibilidadReducida'),
        pool: this.$t('services.Piscina'),
        privatizable: this.$t('services.Privatizable'),
        terrace: this.$t('services.Terraza'),
        wifi: this.$t('services.Wifi'),
      },
      payment: {
        card_payment: this.$t('services.PargoTarjeta'),
        cash_payment: this.$t('services.PagoEfectivo'),
      },
    };
  },
  created () {
    this.getAllCartesPublicSimple({ restaurant_id: this.restaurant.id, language: this.language });
    this.getAllMenusPublicSimple({ restaurant_id: this.restaurant.id, language: this.language });
  },
  computed: {
    ...mapGetters({
      cartes: 'getCartes',
      menus: 'getMenus',
      language: 'getCurrentLanguagePublic',
    }),
    types () {
      if (this.restaurant.types) {
        const arrayTypes = new Array();
        this.restaurant.types.forEach(function (element) {
          arrayTypes.push(element.name);
        });
        return arrayTypes.join(', ');
      } else {
        return '';
      }
    },
    profiles () {
      if (this.restaurant.profiles) {
        const arrayProfiles = new Array();
        this.restaurant.profiles.forEach(function (element) {
          arrayProfiles.push(element.name);
        });
        return arrayProfiles.join(', ');
      } else {
        return '';
      }
    },
    allowCartes () {
      return this.cartes.length;
    },
    allowMenus () {
      return this.menus.length;
    },
  },
  methods: {
    ...mapActions({
      getAllCartesPublicSimple: 'getAllCartesPublicSimple',
      getAllMenusPublicSimple: 'getAllMenusPublicSimple',
    }),
  },
};
</script>

<style>
@import url('//fonts.googleapis.com/css2?family=Raleway:ital,wght@0,400;0,700;1,500&display=swap');
::selection {
  background-color: aliceblue;
}
body,
.modal,
.carta,
.sans-serif {
  font-family: 'Raleway', sans-serif !important;
}
.smooth {
  transition: box-shadow 0.3s ease-in-out;
}
.rounded-lg {
  border-radius: 20px !important;
}
.text-pink-500 {
  color: #d93a58 !important;
}
.bg-pink-500 {
  background: #d93a58 !important;
}
.bg-petrol {
  background: #6cc6bf !important;
}
.text-petrol {
  color: #6cc6bf !important;
}
.border-bt {
  border-bottom: 2px solid #d93a58;
  margin-bottom: -3px;
}
.precio {
  position: absolute;
  right: 1.5em;
  top: -20px;
  font-family: sans-serif;
}
#alergy .text-sm {
  font-size: 0.5em;
  padding-top: 0.5em;
}
.modal {
  transition: opacity 0.25s ease;
}
body.modal-active {
  overflow-x: hidden;
  overflow-y: visible !important;
}
</style>
